<template>
    <v-tooltip v-if="hint" bottom open-on-focus open-on-click max-width="320">
        <template #activator="{ on, attrs }">
            <button
                type="button"
                class="stitch-hint"
                :aria-label="hint"
                v-bind="attrs"
                v-on="on"
                @click.stop.prevent
                @keydown.stop
            >
                <v-icon size="14">mdi-information-outline</v-icon>
            </button>
        </template>
        <span>{{ hint }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "StitchHint",
    props: { hint: { type: String, default: "" } },
};
</script>

<style scoped>
.stitch-hint {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-left: 6px;
    border-radius: 50%;
    vertical-align: middle;
    pointer-events: auto;
}
.stitch-hint:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
}
</style>
